import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import CategoryName from './CategoryName';
import { count, getCategoryVisibleSons } from '@components/config/helpers';
import { Fragment, useEffect, useMemo, useState } from 'react';
import CategorySubCat from './CategorySubCat';
import useCategoryShallowLink from '@components/_hooks/CSRHooks/useCategoryShallowLink';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const CategoriesAccordion = (props) => {
  const {
    idx,
    category,
    findCurrCat
  } = props;

  const { pageSpinner } = useSelector((state) => state.globalReducer);
  const { categoryLoaders } = useSelector((state) => state.categoryReducer);

  const { handleShallowLink } = useCategoryShallowLink();
  const { breadcrumbs } = useSelector((state) => state.globalReducer);
  const router = useRouter();

  const [expanded, setExpanded] = useState(findCurrCat().category);
  const [check, setCheck] = useState(findCurrCat().sub_category);

  const visibleSons = useMemo(() => {
    return getCategoryVisibleSons(category);
  }, [category.category_id])

  const currentCategory = useMemo(() => {
    return findCurrCat();
  }, [check, expanded, router])



  useEffect(() => {
    const results = currentCategory
    if (results?.sub_category != null) {
      setCheck(results.sub_category);
    } else if (results?.sub_category == null) {
      setCheck(null)
    }
    if (results?.category != null) {
      setExpanded(results.category);
    }
  }, [router]);

  const handleCheck = (e, index, slug) => {
    if (pageSpinner || categoryLoaders.fetchingCategory) return;

    setCheck(index);
    handleShallowLink(e, slug)
  };

  const handleChange = (idx) => (event, newExpanded) => {
    if (pageSpinner || categoryLoaders.fetchingCategory) return;

    setExpanded(newExpanded ? idx : null);
    setCheck(null);
  };


  return (
    <Accordion expanded={expanded === idx} onChange={handleChange(idx)}>
      <CategoryName
        route={breadcrumbs?.last}
        check={check}
        idx={idx}
        category={category}
        expanded={expanded}
      />

      {count(category.sons) > 0 &&
        visibleSons.map((son, index) => (
          <Fragment key={son.name}>
            <CategorySubCat
              check={check}
              son={son}
              index={index}
              handleCheck={handleCheck}
            />
          </Fragment>
        ))}
    </Accordion>
  );
};

export default CategoriesAccordion;